{
  "actions": "الإجراءات",
  "hideButtonLabel": "إظهار أقل",
  "noTags": "بدون",
  "showAllButtonLabel": "عرض الكل ({tagCount, number})"
}
